var _path, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "382px",
    height: "512px",
    clipRule: "evenodd",
    fillRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 29.93 40.02",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.21 0h13.38l11.34 11.82v22.99c0 2.88-2.33 5.21-5.2 5.21h-19.52c-2.88 0-5.21-2.33-5.21-5.21v-29.6c0-2.88 2.33-5.21 5.21-5.21z",
    fill: "#251D36"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "18.58 0 18.58 11.73 29.93 11.73",
    fill: "#fff",
    fillOpacity: 0.30196
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m7.56 29.22v-5.69h-2.08v-1.58h6.01v1.58h-2.07v5.69h-1.86zm10.69 0h-1.95l-1.33-2.23-1.33 2.23h-1.96l2.31-3.88-2.02-3.39h1.95l1.05 1.76 1.04-1.76h1.96l-2.02 3.4 2.3 3.87zm2.26 0v-5.69h-2.07v-1.58h6.01v1.58h-2.08v5.69h-1.86z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.916fc7fd57ad7faf2f44a057ded24abd.svg";
export { ForwardRef as ReactComponent };